module.exports = __webpack_public_path__ + "static/media/profile.5948960d.svg";